import { useMatch } from 'react-router-dom';

import {
  FOOTBALL_MARKET_INSTANT_BUY,
  FOOTBALL_MARKET_MANAGER_SALES,
  FOOTBALL_MARKET_NEW_SIGNINGS,
  FOOTBALL_MY_CLUB_SLUG_CARDS,
} from '@sorare/core/src/constants/__generated__/routes';

// REMOVE ME - AFTER 2024-07-01 EOD
// LINEAR [MAR-810]
export const useShowEuropeanChampionshipTooltip = () => {
  const matchInstantBuy = useMatch(FOOTBALL_MARKET_INSTANT_BUY);
  const matchManagerSales = useMatch(FOOTBALL_MARKET_MANAGER_SALES);
  const matchNewSignings = useMatch(FOOTBALL_MARKET_NEW_SIGNINGS);
  const matchMyClubCards = useMatch(FOOTBALL_MY_CLUB_SLUG_CARDS);
  return (
    !!matchInstantBuy ||
    !!matchManagerSales ||
    !!matchNewSignings ||
    !!matchMyClubCards
  );
};
